export default {
  'no-kid-found:title': 'Мемлекеттік базадан балаларыңыз туралы дерек таба алмадық.',
  'no-kid-found:call-center-not-found': 'Бар сұрақ бойынша мына нөмірге хабарласыңыз',
  'no-kid-found:btn': 'Kaspi.kz бас бетіне қайту'
}
